"use client"

import Link from "next/link"
import { useState } from "react"

const ToolTip = ({toolTipCaption}) =>{
     return (
          // had whitespace-nowrap. 
          <div className="
               absolute bottom-full left-1/2 -translate-x-1/2 -mb-1
               px-2 py-1 text-xs text-white bg-slate-800 rounded
               opacity-0 group-hover:opacity-100
               transition-opacity pointer-events-none
               z-10 min-w-32 text-center
          ">
        {toolTipCaption}
      </div>
     )
}


const IndigoButton = ({caption, onClick, width, onMouseDown, iconClassName, loading, border, buttonSize}) => { 
     return (
          <button type="submit" 
          disabled={loading ? true : false }
          className={`w-full min-h-10 ${buttonSize === 1 ? 'max-h-14 py-4 text-sm' : 'max-h-10 py-2 text-xs'} px-4 whitespace-nowrap transition duration-300 ${border && 'border-2 border-indigo-600'} ease-in-out inline-flex items-center  font-base text-center justify-center text-white ${loading ? 'bg-gray-400' : 'bg-indigo-600'} rounded-md ${width} hover:bg-indigo-700`}
          onClick={onClick} 
          onMouseDown={onMouseDown}>
          {loading ? <>
          <div className="button-loader bg-white mr-2"></div>
          <span>{caption}</span>
          </> : <>{caption}</>}
             {/* {caption} <i className={`${iconClassName && 'ml-1 ' + iconClassName}`}></i> */}

         </button>
     )
}

const TealButton = ({caption, disabled, onClick, borderOnly=false, fontSize, rounded, width, onMouseDown, iconClassName, loading, border, textSize, buttonSize}) => { 
     return (
          <button type="submit"
          disabled={(loading || disabled) ? true : false }
          className={`${buttonSize === 1 ? 'min-h-14 max-h-14 py-4 text-sm' : 'min-h-10 max-h-10 py-2 text-xs'} font-inter w-full whitespace-nowrap transition duration-300 
               ${border && 'border-2 border-teal-300'}
               ease-in-out inline-flex items-center px-4 text-center justify-center 
               ${loading ? 'bg-slate-300' : borderOnly ? 'bg-transparent text-black dark:text-slate-400 hover:text-white' : 'text-white bg-teal-400'} rounded-md ${width} hover:bg-teal-500`}
          onClick={onClick} 
          onMouseDown={onMouseDown}>
          {loading ? <>
          <div className="button-loader bg-white mr-2"></div>
          <span>{caption}</span>
          </> 
          : 
          <>{caption}</>}
             {/* {caption} <i className={`${iconClassName && 'ml-1 ' + iconClassName}`}></i> */}

         </button>
     )
}


const NewRecordButton = ({caption, onClickMethod=()=>{}, icon='fa-regular fa-folder-closed', shadow}) => {
     return (
              <div onClick={onClickMethod} className={`${shadow} cursor-pointer flex items-center text-xs bg-slate-100 dark:bg-slate-700 dark:text-slate-400 ${caption ? 'rounded-xl pr-4' : 'rounded-full'} hover:text-teal-400 transition-all duration-150`}>
              <div  className="cursor-pointer hover:text-teal-400 rounded-full h-10 w-10 bg-slate-100 dark:bg-slate-700 flex items-center justify-center">
        <i className={`text-base ${icon}`} />
                            <div className="absolute text-xs -mr-3 -mb-2.5 h-2.5 w-2.5 rounded-full p-0.5 bg-slate-50 dark:bg-slate-700 flex items-center justify-center">+</div>
        </div>
       {caption && <div>{caption}</div>}
        </div>
     )
}



const LinkButton = ({href, caption, underCaption, arrowIcon='fa-arrow-right', arrowPosition='RIGHT', arrowRotation='-rotate-45'})=> {
     // unused right now
     const [hovering, setHovering] = useState(false)
     return (
                   <Link
                   onMouseEnter={()=>setHovering(true)}
                   onMouseLeave={()=>setHovering(false)}
              href={href}
                  className="duration-500 hover:border-teal-400 text-xl font-ubuntu">
                    <span className="flex flex-col items-start">
                      <span className="flex flex-row gap-2">
                 {/* <span className="relative hover:underline duration-300 transition-all text-black dark:text-white decoration-4 underline-offset-4 decoration-teal-300"> */}
                 <span className="relative text-black dark:text-white after:block after:h-[4px] after:bg-teal-300 after:w-0 after:transition-all after:duration-300 hover:after:w-full">

                {caption}
                  {/* <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-teal-300 transition-all duration-300 group-hover:w-full"></span> */}

                </span>
                 {arrowPosition === 'RIGHT' && <span className={`flex items-start justify-center ${arrowRotation}`}><i className={`fa-solid ${arrowIcon} text-lg ${hovering && 'scale-150'} text-teal-300 duration-150`}/>
                 </span>}
                </span>
               {underCaption && <p className="text-xs font-light underline-none italic font-inter">{underCaption}</p>}
               </span>
            </Link>
          )
}













/*------------------------------------------
     TEXTINPUT SERIES
-------------------------------------------*/

// was bottom-0 before the bg introduction 

const PlaneButton = ({caption, onClick, fontSize, rounded, width, onMouseDown, iconClassName, loading, border, textSize, buttonSize, toolTipCaption})=>{
     return (

                    <div className="absolute bottom-0 right-3 right-12 group">
          {/* Tooltip */}
      {toolTipCaption && <ToolTip toolTipCaption={toolTipCaption}/>}
            <button 
            type="submit" 
               disabled={loading ? true : false }
               onClick={onClick} 
          onMouseDown={onMouseDown}
          className={`flex items-center justify-center h-9 w-9 rounded-full text-slate-500 hover:text-teal-400  transition`}
  >
     {loading ? <>
          <div className="button-loader bg-white mr-2"></div></> :
    <i className="fa-regular fa-paper-plane text-base" />}
  </button>
  </div>
     )
}


const FloppyDiskButton = ({caption, onClick, fontSize, rounded, width, onMouseDown, iconClassName, loading, border, textSize, buttonSize, toolTipCaption, disabled})=>{
     return (

          <div className="absolute bottom-0 right-12 group">
          {/* Tooltip */}
      <ToolTip toolTipCaption={toolTipCaption}/>
            <button 
            type="submit" 
               disabled={disabled || loading}
               onClick={onClick} 
          onMouseDown={onMouseDown}
          className={`flex items-center justify-center h-9 w-9 rounded-full text-slate-500 hover:text-teal-400  transition`}
          >
     {loading ? <>
          <div className="button-loader bg-white mr-2"></div></> :
    <i className="fa-regular fa-floppy-disk text-base" />}
  </button>
  </div>
     )
}


const AnonymousButton = ({toolTipCaption, disabled=false, onClick, fontSize, rounded, width, onMouseDown, iconClassName, loading, border, textSize, buttonSize, isAnonymous})=>{
     return (
                    <div className="absolute bottom-0 right-28 group">
      {/* Tooltip */}
      
      <ToolTip toolTipCaption={toolTipCaption}/>

      {/* Button */}
      <button
        type="button"
        disabled={loading || disabled}
        onClick={onClick}
        onMouseDown={onMouseDown}
        className={`
          flex items-center justify-center h-9 w-9 rounded-full transition
          ${disabled 
               ? 
          'text-slate-300 dark:text-slate-500' 
          : 
          isAnonymous 
          ?
          'text-teal-400'
          :
          'text-slate-500 hover:text-teal-400 dark:text-slate-500'}
        `}
      >
        {loading ? (
          <div className="button-loader bg-white" />
        ) : (
          <i className="fa-solid fa-user-secret text-base" />
        )}
      </button>
    </div>
//             <button 
//             type="button" 
//                disabled={loading ? true : false }
//                onClick={onClick} 
//           onMouseDown={onMouseDown}
//             className={`absolute bottom-3 right-20 flex items-center justify-center h-9 w-9 rounded-full hover:text-teal-400 ${isAnonymous ? 'text-teal-400' : 'text-slate-500'} transition`}
//   >
//      {loading ? <>
//           <div className="button-loader bg-white mr-2"></div></> :
//     <i className="fa-solid fa-user-secret text-base" />}
//   </button>
     )
}


const TimelessPostButton = ({toolTipCaption, disabled=false, onClick, fontSize, rounded, width, onMouseDown, iconClassName, loading, border, textSize, buttonSize, isTimeless})=>{
     return (
                    <div className="absolute bottom-0 right-36 group">
      {/* Tooltip */}
      
      <ToolTip toolTipCaption={toolTipCaption}/>

      {/* Button */}
      <button
        type="button"
        disabled={loading || disabled}
        onClick={onClick}
        onMouseDown={onMouseDown}
        className={`
          flex items-center justify-center h-9 w-9 rounded-full transition
          ${disabled 
               ? 
          'text-slate-300 dark:text-slate-500' 
          : 
          isTimeless 
          ?
          'text-teal-400'
          :
          'text-slate-500 hover:text-teal-400 dark:text-slate-500'}
        `}
      >
        {loading ? (
          <div className="button-loader bg-white" />
        ) : (
          <i className="fa-regular fa-clock text-base" />
        )}
      </button>
    </div>
//             <button 
//             type="button" 
//                disabled={loading ? true : false }
//                onClick={onClick} 
//           onMouseDown={onMouseDown}
//             className={`absolute bottom-3 right-20 flex items-center justify-center h-9 w-9 rounded-full hover:text-teal-400 ${isAnonymous ? 'text-teal-400' : 'text-slate-500'} transition`}
//   >
//      {loading ? <>
//           <div className="button-loader bg-white mr-2"></div></> :
//     <i className="fa-solid fa-user-secret text-base" />}
//   </button>
     )
}


const PreviewPostButton = ({toolTipCaption, disabled=false, onClick, fontSize, rounded, width, onMouseDown, iconClassName, loading, border, textSize, buttonSize, isActive})=>{
     return (
                    <div className="absolute bottom-0 right-36 group">
      {/* Tooltip */}
      
      <ToolTip toolTipCaption={toolTipCaption}/>

      {/* Button */}
      <button
        type="button"
        disabled={loading || disabled}
        onClick={onClick}
        onMouseDown={onMouseDown}
        className={`
          flex items-center justify-center h-9 w-9 rounded-full transition
          ${disabled 
               ? 
          'text-slate-300 dark:text-slate-500' 
          : 
          isActive 
          ?
          'text-teal-400'
          :
          'text-slate-500 hover:text-teal-400 dark:text-slate-500'}
        `}
      >
        {loading ? (
          <div className="button-loader bg-white" />
        ) : (
          <i className="fa-solid fa-binoculars text-base" />
        )}
      </button>
    </div>
//             <button 
//             type="button" 
//                disabled={loading ? true : false }
//                onClick={onClick} 
//           onMouseDown={onMouseDown}
//             className={`absolute bottom-3 right-20 flex items-center justify-center h-9 w-9 rounded-full hover:text-teal-400 ${isAnonymous ? 'text-teal-400' : 'text-slate-500'} transition`}
//   >
//      {loading ? <>
//           <div className="button-loader bg-white mr-2"></div></> :
//     <i className="fa-solid fa-user-secret text-base" />}
//   </button>
     )
}


const MediaAttachmentButton = ({toolTipCaption, isActive, disabled, onClick, fontSize, rounded, width, onMouseDown, iconClassName, loading, border, textSize, buttonSize})=>{
     return (
          <div className="absolute bottom-0 right-20 group">
      {/* Tooltip */}
           <ToolTip toolTipCaption={toolTipCaption}/>

      {/* Button */}
      <button
        type="button"
        disabled={loading || disabled}
        onClick={onClick}
        onMouseDown={onMouseDown}
        className={`
          flex items-center justify-center h-9 w-9 rounded-full transition
          ${disabled ? 'text-slate-300 dark:text-slate-500' : `${isActive ? 'text-teal-400' : 'text-slate-500'} hover:text-teal-400 dark:text-slate-500`}
        `}
      >
        {loading ? (
          <div className="button-loader bg-white" />
        ) : (
          <i className="fa-regular fa-images text-base" />
        )}
      </button>
    </div>
//             <button 
//             type="button" 
//                disabled={(loading || disabled) ? true : false }
//                onClick={onClick} 
//           onMouseDown={onMouseDown}
//             className={`absolute bottom-3 right-12 flex items-center justify-center h-9 w-9 rounded-full transition ${disabled ? 'text-slate-300' : 'text-slate-500 hover:text-teal-400'}
//                `}
//   >
//      {loading ? <>
//           <div className="button-loader bg-white mr-2"></div></> :
//     <i className="fa-regular fa-images text-base" />}
    
//   </button>
     )
}











/*=================================
|---ROUND SERIES
=================================*/
const RoundButton = ({href='#', caption, onClick, disabled, iconClassName, order='iconBeforeCaption'}) => { // used primarily for navigation (ex: social thread back button)

     // order can be: 
     // iconBeforeCaption
     // captionBeforeIcon
     
     return (
     <Link disabled={disabled} href={href} onClick={onClick} className="z-50 flex items-center h-14 flex gap-4">
          <div className={`${order==='iconBeforeCaption' ? 'order-1' : 'order-2'} hover:text-teal-400 transition-all duration-150 rounded-full h-10 w-10 bg-slate-100 dark:bg-slate-700 flex items-center justify-center`}>
        <i className={`text-base ${iconClassName || 'fa-solid fa-arrow-left-long'}`} />
        </div>
        {caption && <span className={`${order==='iconBeforeCaption' ? 'order-2' : 'order-1'} text-lg`}>{caption}</span>}
      </Link>
     )
}







/*------------------------------------------
     OVAL SQUARE SERIES
-------------------------------------------*/

const ArrowUpButton = ({disabled, caption, onClick, fontSize, rounded, width, onMouseDown, iconClassName, loading, border, textSize, buttonSize, reacted})=>{

     return (
          
            <button 
            type="button"
               disabled={(loading || disabled) ? true : false }
               onClick={onClick} 
          onMouseDown={onMouseDown}
            className={`
               text-xs
                     rounded-xl
                    bg-slate-100
                    p-4
                    h-12 w-12
                    focus:outline-none
                    dark:bg-transparent
               ease-in-out duration-300 inline-flex items-center text-center justify-center ${disabled === false && 'hover:text-teal-400 hover:bg-slate-200 dark:hover:bg-slate-600'} ${reacted ? 'text-teal-400 dark:text-teal-400' : 'text-slate-500 dark:text-slate-400'}`}
  >
     {loading 
     ? 
     <>
          <div className="button-loader bg-white mr-2"></div>
     </> 
     :
    <div className="flex gap-1">
     <span>{caption}</span><span><i className="fa-solid fa-arrow-up-long"></i></span>
    </div>
    }
  </button>
     )
}

const EditButton = ({disabled, caption, onClick, fontSize, rounded, width, onMouseDown, iconClassName, loading, border, textSize, buttonSize, active})=>{

     return (
          
            <button 
            type="button"
               disabled={(loading || disabled) ? true : false }
               onClick={onClick} 
          onMouseDown={onMouseDown}
            className={`
               text-xs
                     rounded-xl
                    bg-slate-100
                    p-4
                    h-12 w-12
                    focus:outline-none
                    dark:bg-transparent
               ease-in-out duration-300 inline-flex items-center text-center justify-center ${disabled === false && 'hover:text-teal-400 hover:bg-slate-200 dark:hover:bg-slate-600'} ${active ? 'text-teal-400 dark:text-teal-400' : 'text-slate-500 dark:text-slate-400'}`}
  >
     {loading 
     ? 
     <>
          <div className="button-loader bg-white mr-2"></div>
     </> 
     :
    <div className="flex gap-1">
     {caption && <span>{caption}</span>}<span><i className="fa-solid fa-pen"></i></span>
    </div>
    }
  </button>
     )
}

const MinusButton = ({disabled=false, caption, onClick, fontSize, rounded, width, onMouseDown, iconClassName, loading, border, textSize, buttonSize, activated})=>{

     return (
          
            <button 
            type="button"
               disabled={(loading || disabled) ? true : false }
               onClick={onClick} 
          onMouseDown={onMouseDown}
            className={`
               text-xs
                     rounded-xl
                    bg-slate-100
                    p-4
                    focus:outline-none
                    dark:bg-transparent
               ease-in-out duration-300 inline-flex items-center text-center justify-center 
               ${disabled === false && 'hover:text-rose-400 hover:bg-slate-200 dark:hover:bg-slate-600'} 
               ${activated ? 'text-teal-400 dark:text-teal-400' : 'text-slate-500 dark:text-slate-400'}
               `}
  >
     {loading 
     ? 
     <>
          <div className="button-loader bg-white mr-2"></div>
     </> 
     :
    <div className="flex gap-1">
     {caption && <span>{caption}</span>}<span><i className="fa-solid fa-minus text-sm"></i></span>
    </div>
    }
  </button>
     )
}

const CommentButton = ({disabled, caption, onClick, fontSize, rounded, width, onMouseDown, iconClassName, loading, border, textSize, buttonSize, commented})=>{
     return (
            <button 
          //   shallow={true}
          //   href=''
          type="button"
               disabled={(loading || disabled) ? true : false }
               onClick={onClick} 
          onMouseDown={e=>e.preventDefault()}
            className={`
               text-xs
                     rounded-xl
                    bg-slate-100
                    p-4
                    h-12 w-12
                    focus:outline-none
                    dark:bg-transparent
               ease-in-out duration-300 inline-flex items-center text-center justify-center 
               ${disabled === false && 'hover:text-teal-400 hover:bg-slate-200 dark:hover:bg-slate-600'} 
               ${commented ? 'text-teal-400 dark:text-teal-400 ' : 'text-slate-500 dark:text-slate-400'}`}
  >
     {loading 
     ? 
     <>
          <div className="button-loader bg-white mr-2"></div>
     </> 
     :
    <div className="flex gap-1">
     {caption && <span>{caption}</span>}<span><i className="fa-regular fa-comment"></i></span>
    </div>
    }
  </button>
     )
}

const TrashButton = ({disabled, caption, onClick, fontSize, rounded, width, onMouseDown, iconClassName, loading, border, textSize, buttonSize, deleteConfirmation})=>{
     return (
            <button 
            type="button"
               disabled={(loading || disabled) ? true : false }
               onClick={onClick} 
          onMouseDown={onMouseDown}
            className={`
               text-xs
               w-12 h-12
                     rounded-xl
                    bg-slate-100
               ${disabled === false && 'hover:text-teal-400 hover:bg-slate-200 dark:hover:bg-slate-600'} 
                    p-4
                    focus:outline-none
                    dark:bg-transparent
               ease-in-out duration-300 inline-flex items-center text-center justify-center text-slate-500 dark:text-slate-400 text-xs`}
  >
     {loading 
     ? 
     <>
          <div className="button-loader bg-white mr-2"></div>
     </> 
     :
    <div className="flex gap-1">
     {caption && <span>{caption}</span>}<span>
          {deleteConfirmation === 1 ?
          <i className="fa-solid fa-trash-can text-red-500"></i> :
          <i className="fa-regular fa-trash-can"></i>}
          </span>
    </div>
    }
  </button>
     )
}

const CopyUrlButton = ({disabled=false, caption, onClick, fontSize, rounded, width, onMouseDown, iconClassName, loading, border, textSize, buttonSize, activated})=>{

     return (

            <button 
            type="button"
               disabled={(loading || disabled) ? true : false }
               onClick={onClick} 
          onMouseDown={onMouseDown}
            className={`
               text-xs
                     rounded-xl
                    bg-slate-100
                    p-4
                    w-12 h-12
                    focus:outline-none
                    dark:bg-transparent
               ease-in-out duration-300 inline-flex items-center text-center justify-center 
               ${disabled === false && 'hover:text-teal-400 hover:bg-slate-200 dark:hover:bg-slate-600'} 
               ${activated ? 'text-teal-400 dark:text-teal-400' : 'text-slate-500 dark:text-slate-400'}
               `}
  >
     {loading 
     ? 
     <>
          <div className="button-loader bg-white mr-2"></div>
     </> 
     :
    <div className="flex gap-1">
     {caption && <span>{caption}</span>}<span><i className="fa-solid fa-link text-sm"></i></span>
    </div>
    }
  </button>
     )
}

const ConfirmOrCancelButton = ({disabled=false, caption, onClick, confirmOrCancel='CONFIRM', rounded, width, onMouseDown, iconClassName, loading, border, textSize, buttonSize, activated, visible=true})=>{

     return (
          
            <button 
            type="button"
               disabled={(loading || disabled) ? true : false }
               onClick={onClick} 
          onMouseDown={onMouseDown}
            className={`
               text-xs
               w-12 h-12
                     rounded-xl
                    bg-slate-100
                    p-4
                    focus:outline-none
                    dark:bg-transparent
               ease-in-out duration-300 inline-flex items-center text-center justify-center 
               ${visible === false && 'hidden'}
               ${disabled === false && `${confirmOrCancel === 'CONFIRM' ? 'hover:text-teal-400' : 'hover:text-red-400'} hover:bg-slate-200 dark:hover:bg-slate-600`} 
               ${activated ? 'text-teal-400 dark:text-teal-400' : 'text-slate-500 dark:text-slate-400'}
               `}
  >
     {loading 
     ? 
     <>
          <div className="button-loader bg-white mr-2"></div>
     </> 
     :
    <div className="flex gap-1">
     {caption && <span>{caption}</span>}<span>
          <i className={`fa-solid ${confirmOrCancel === 'CONFIRM' ? 'fa-check' : 'fa-xmark'} text-sm`}></i>
          </span>
    </div>
    }
  </button>
     )
}

const OpenUrlButton = ({disabled, caption, url, commented, onClick, fontSize, rounded, width, onMouseDown, iconClassName, loading, border, textSize, buttonSize,})=>{

     const [hovering, setHovering] = useState(false)
     return (
            <Link
            onMouseEnter={()=>setHovering(true)}
            onMouseLeave={()=>setHovering(false)}
          //   shallow={true}
            href={url || '#'}
          // type="button"
               disabled={(loading || disabled) ? true : false }
               onClick={onClick} 
          onMouseDown={e=>e.preventDefault()}
            className={`
               ${url === null && 'hidden'}
               text-xs
               w-12
               h-12
                     rounded-xl
                    bg-slate-100
                    p-4
                    focus:outline-none
                    dark:bg-transparent
               ease-in-out duration-300 inline-flex items-center text-center justify-center 
               ${disabled === false && 'hover:text-teal-400 hover:bg-slate-200 dark:hover:bg-slate-600'} 
               ${commented ? 'text-teal-400 dark:text-teal-400 ' : 'text-slate-500 dark:text-slate-400'}
               `}
  >
     {loading 
     ? 
     <>
          <div className="button-loader bg-white mr-2"></div>
     </> 
     :
    <div className="flex gap-1">
     {caption && <span>{caption}</span>}<span><i className={`fa-solid fa-arrow-right transition-all duration-150 ${hovering && '-rotate-45'}`}></i></span>
    </div>
    }
  </Link>
     )
}

// const SocialShareButton = ({disabled=false, href='#', caption, onClick, socialNetwork, rounded, width, onMouseDown, iconClassName, loading, border, textSize, buttonSize, commented})=>{

//      const socialNetworkMap = {
//           linkedin: 'fa-brands fa-linkedin-in',
//           facebook: 'fa-brands fa-facebook-f',
//           email: 'fa-regular fa-envelope',
//           twitter: 'fa-brands fa-x-twitter',
//           bluesky: 'fa-brands fa-bluesky',
//           reddit: 'fa-brands fa-reddit-alien'
//      }

//      const encoded = encodeURIComponent(href);
//      window.open(
//     `https://www.linkedin.com/sharing/share-offsite/?url=${encoded}`,
//     '_blank',
//     'noopener,noreferrer'
//      );

//      return (
//             <Link 
//             shallow={true}
//             rel={"noopener noreferrer"}
//             href={href}
//           type="button"
//                disabled={(loading || disabled) ? true : false }
//                onClick={onClick} 
//           onMouseDown={e=>e.preventDefault()}
//             className={`
//                text-xs
//                      rounded-xl
//                     bg-slate-100
//                     p-4
//                     h-12 w-12
//                     focus:outline-none
//                     dark:bg-transparent
//                ease-in-out duration-300 inline-flex items-center text-center justify-center 
//                ${disabled === false && 'hover:text-teal-400 hover:bg-slate-200 dark:hover:bg-slate-600'} 
//                ${commented ? 'text-teal-400 dark:text-teal-400 ' : 'text-slate-500 dark:text-slate-400'}`}
//   >
//      {loading 
//      ? 
//      <>
//           <div className="button-loader bg-white mr-2"></div>
//      </> 
//      :
//     <div className="flex gap-1">
//      {caption && <span>{caption}</span>}<span><i className={socialNetworkMap[socialNetwork]}></i></span>
//     </div>
//     }
//   </Link>
//      )
// }




const MultipurposeOvalButton = ({disabled=false, purpose, caption, onClick, fontSize, rounded, width, onMouseDown, iconClassName, loading, border, textSize, buttonSize, active})=>{
     const purposeMap = {
          share: 'fa-solid fa-arrow-up-from-bracket'
     }
     return (
          
            <button 
            type="button"
               disabled={(loading || disabled) ? true : false }
               onClick={onClick} 
          onMouseDown={onMouseDown}
            className={`
               text-xs
                     rounded-xl
                    bg-slate-100
                    p-4
                    h-12 w-12
                    focus:outline-none
                    dark:bg-transparent
               ease-in-out duration-300 inline-flex items-center text-center justify-center ${disabled === false && 'hover:text-teal-400 hover:bg-slate-200 dark:hover:bg-slate-600'} ${active ? 'text-teal-400 dark:text-teal-400' : 'text-slate-500 dark:text-slate-400'}`}
  >
     {loading 
     ? 
     <>
          <div className="button-loader bg-white mr-2"></div>
     </> 
     :
    <div className="flex gap-1">
     {caption && <span>{caption}</span>}<span><i className={purposeMap[purpose]}></i></span>
    </div>
    }
  </button>
     )
}



const SocialShareButton = ({
  disabled = false,
  href = '#',
  caption,
  socialNetwork,
  loading,
  commented,
  captionToShare,
  bodyToShare,
}) => {
  const socialNetworkMap = {
    linkedin: 'fa-brands fa-linkedin-in',
    facebook: 'fa-brands fa-facebook-f',
    email: 'fa-regular fa-envelope',
    twitter: 'fa-brands fa-x-twitter',
    bluesky: 'fa-brands fa-bluesky',
    reddit: 'fa-brands fa-reddit-alien',
  };

  const handleShare = e => {
    e.preventDefault();
    let shareUrl;
    if (disabled || loading) return;

     const encoded = encodeURIComponent(href);
     if (socialNetwork === 'linkedin') {
          shareUrl = `https://linkedin.com/sharing/share-offsite/?url=${encoded}&utm_campaign=post-expanded-share&utm_medium=web`
     
     }
     else if (socialNetwork === 'facebook') {
          shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encoded}`
     }
     else if (socialNetwork === 'facebook') {
          shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encoded}`
     }
     else if (socialNetwork === 'twitter') {
          // shareUrl = `https://twitter.com/intent/tweet?text=${captionToShare + '%0Avia @TalnetHQ%0A'}&url=${encoded}`
          shareUrl = `https://twitter.com/intent/tweet?text=${captionToShare}&url=${encoded}`
     }
          else if (socialNetwork === 'reddit') {
          shareUrl = `https://www.reddit.com/submit?url=${encoded}&title=${captionToShare}`
     }
     else if (socialNetwork === 'bluesky') {
          shareUrl = `https://bsky.app/intent/compose?text=${captionToShare + '%0A%0A' + encoded}`
     }
     else if (socialNetwork === 'email') {
          shareUrl = `mailto:?subject=${encodeURIComponent(captionToShare || 'Interesting post on Talnet')}&body=${bodyToShare || `Check out this post on Talnet:%0A${encoded}`}`;
    }
    
     window.open(shareUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      type="button"
      disabled={disabled || loading}
      onClick={handleShare}
      className={`
        text-xs rounded-xl p-4 h-12 w-12
        inline-flex items-center justify-center
        bg-slate-100 dark:bg-transparent
        ease-in-out duration-300
        ${!disabled && 'hover:text-teal-400 hover:bg-slate-200 dark:hover:bg-slate-600'}
        ${commented ? 'text-teal-400' : 'text-slate-500 dark:text-slate-400'}
      `}
    >
      {loading ? (
        <div className="button-loader bg-white" />
      ) : (
        <div className="flex gap-1 items-center">
          {caption && <span>{caption}</span>}
          <i className={socialNetworkMap[socialNetwork]} />
        </div>
      )}
    </button>
  );
};









const FollowButton = ({disabled, hoveringCaption, caption, onClick, fontSize, rounded, width, onMouseDown, iconClassName, loading, border, textSize, buttonSize, followed})=>{
     const [hovering, setHovering] = useState(false)

     return (
            <button 
          onClick={onClick}
          onMouseDown={onMouseDown}
          onMouseEnter={()=>setHovering(true)}
          onMouseLeave={()=>setHovering(false)}
          type="button"
               disabled={(loading || disabled) ? true : false }
            className={`
                     rounded
                    bg-slate-100
                    px-4
                    py-1
                    focus:outline-none
                    dark:bg-transparent
                    hover:text-teal-400
                    border
                    border-slate-100
                    dark:border-slate-600
                    hover:bg-white hover:border-teal-400 dark:hover:bg-slate-600
               ease-in-out duration-300 inline-flex items-center text-center justify-center 
               ${disabled === false && 'hover:text-teal-400 hover:bg-slate-200 dark:hover:bg-slate-600'} 
               ${followed ? 'text-teal-400 dark:text-teal-400 ' : 'text-slate-500 dark:text-slate-400'}`}
  >

     {loading 
     ? 
     <div className="flex gap-1">
          <span className="button-loader bg-slate-400 mr-2"></span>{caption && <span className="text-xs flex items-center">{caption}</span>}
     </div> 
     :
    <div className="flex gap-1">
     <span className="flex items-center"><i className={`fa-solid ${followed ? 'fa-check' : 'fa-plus'} text-xs`}></i></span>{caption && <span className="text-xs flex items-center transition-all duration-500 ease-in-out">{hovering ? hoveringCaption : caption}</span>}
    </div>
    }
  </button>
     )
}

const MessageButton = ({disabled, hoveringCaption, caption, onClick, fontSize, rounded, width, onMouseDown, iconClassName, loading, border, textSize, buttonSize, href="#"})=>{
     const [hovering, setHovering] = useState(false)

     return (
            <Link 
            href={href}
          onClick={onClick}
          onMouseDown={onMouseDown}
          onMouseEnter={()=>setHovering(true)}
          onMouseLeave={()=>setHovering(false)}
          type="button"
               disabled={(loading || disabled) ? true : false }
            className={`
                     rounded
                    bg-slate-100
                    px-4
                    py-1
                    focus:outline-none
                    dark:bg-transparent
                    hover:text-teal-400
                    border
                    border-slate-100
                    dark:border-slate-600
                    hover:bg-white hover:border-teal-400 dark:hover:bg-slate-600
               ease-in-out duration-300 inline-flex items-center text-center justify-center 
               ${disabled === false && 'hover:text-teal-400 hover:bg-slate-200 dark:hover:bg-slate-600'} 
               ${'text-slate-500 dark:text-slate-400'}`}
  >

     {loading 
     ? 
     <div className="flex gap-1">
          <span className="button-loader bg-slate-400 mr-2"></span>{caption && <span className="text-xs flex items-center">{caption}</span>}
     </div> 
     :
    <div className="flex gap-1">
     <span className="flex items-center"><i className={`fa-solid ${'fa-plus'} text-xs`}></i></span>{caption && <span className="text-xs flex items-center transition-all duration-500 ease-in-out">{hovering ? hoveringCaption : caption}</span>}
    </div>
    }
  </Link>
     )
}




const GradientButton = ({caption, onClick, fontSize, rounded, width, onMouseDown, iconClassName, loading, border, textSize, height=10, buttonSize}) => { 
     return (
          <button type="submit" 
          disabled={loading ? true : false }
          className={`${buttonSize === 1 ? 'max-h-14 py-4 text-sm' : 'max-h-10 py-2 text-xs'} relative bg-gradient-to-r from-cyan-600 via-teal-400 to-teal-400 w-full whitespace-nowrap inline-flex items-center py-2 px-4 
               ${border && 'border-2 border-teal-400'}
               ${textSize || 'text-xs'} font-base text-center justify-center text-white 
               ${loading ? 'bg-gray-400' : 'bg-teal-400'} 
               rounded-md ${width} transition duration-300 ease-in-out font-ubuntu`}
          onClick={onClick} 
          onMouseDown={onMouseDown}>
          {loading ? <>
          <div className="button-loader bg-white mr-2"></div>
          <span>{caption}</span>
          </> : <>
          
   <span
     className={`absolute inset-0 rounded-md bg-gradient-to-r from-cyan-600 via-cyan-500 to-teal-400 transition duration-300 ease-in-out opacity-0 hover:opacity-100`}
   ></span>
   <span className="relative z-10">
     {caption}
   </span>
          </>}
             {/* {caption} <i className={`${iconClassName && 'ml-1 ' + iconClassName}`}></i> */}

         </button>
     )
}

// const GradientButton = ({caption, onClick, fontSize, rounded, width, onMouseDown, iconClassName, loading, border, textSize}) => { 
//      return (
//           <button type="submit" 
//           disabled={loading ? true : false }
//           className={`min-h-10 max-h-10 w-full whitespace-nowrap transition duration-300 bg-gradient-to-r from-cyan-600 via-teal-400 to-teal-400
//                ${border && 'border-2 border-teal-300'}
//                ease-in-out inline-flex items-center py-2 px-4 ${textSize || 'text-xs'} font-base text-center justify-center text-white ${loading ? 'bg-gray-400' : 'bg-teal-400'} rounded-md ${width} hover:from-cyan-600 hover:via-cyan-600 hover:to-teal-400`}
//           onClick={onClick} 
//           onMouseDown={onMouseDown}>
//           {loading ? <>
//           <div className="button-loader bg-white mr-2"></div>
//           <span>{caption}</span>
//           </> : <>
//      {caption}
//           </>}

//          </button>
//      )
// }

const VioletButton = ({caption, onClick, fontSize, rounded, width, onMouseDown, iconClassName, loading}) => { 
     return (
          <button type="submit" 
          disabled={loading ? true : false }
          className={`min-h-8 max-h-8 transition duration-300 ease-in-out inline-flex items-center py-2 px-4 text-xs font-base text-center justify-center text-white ${loading ? 'bg-gray-400' : 'bg-violet-600'} rounded-md ${width} hover:bg-violet-700`}
          onClick={onClick} onMouseDown={onMouseDown}>
          {loading ? <>
          <div className="button-loader bg-white mr-2"></div>
          <span>{caption}</span>
          </> : <>{caption}</>}
             {/* {caption} <i className={`${iconClassName && 'ml-1 ' + iconClassName}`}></i> */}

         </button>
     )
}

const FuchsiaButton = ({caption, onClick, fontSize, rounded, width, onMouseDown, iconClassName, loading}) => { 
     return (
          <button type="submit" 
          disabled={loading ? true : false }
          className={`min-h-8 max-h-8 transition duration-300 ease-in-out inline-flex items-center py-2 px-4 text-xs font-base text-center justify-center text-white ${loading ? 'bg-fuchsia-400' : 'bg-fuchsia-600'} rounded-md ${width} hover:bg-fuchsia-700`}
          onClick={onClick} onMouseDown={onMouseDown}>
          {loading ? <>
          <div className="button-loader bg-white mr-2"></div>
          <span>{caption}</span>
          </> : <>{caption}</>}
             {/* {caption} <i className={`${iconClassName && 'ml-1 ' + iconClassName}`}></i> */}

         </button>
     )
}

const PinkButton = ({caption, onClick, fontSize, rounded, width, onMouseDown, iconClassName, loading, border}) => { 
     return (
          <button type="submit" 
          disabled={loading ? true : false }
          className={`min-h-8 max-h-8 transition ${border && 'border-2 border-pink-400'} duration-300 ease-in-out inline-flex items-center py-2 px-4 text-xs font-base text-center justify-center text-white ${loading ? 'bg-pink-400' : 'bg-pink-600'} rounded-md ${width} hover:bg-pink-700`}
          onClick={onClick} onMouseDown={onMouseDown}>
          {loading ? <>
          <div className="button-loader bg-white mr-2"></div>
          <span>{caption}</span>
          </> : <>{caption}</>}
             {/* {caption} <i className={`${iconClassName && 'ml-1 ' + iconClassName}`}></i> */}

         </button>
     )
}


const BlackButton = ({caption, onClick, fontSize, rounded, width}) => { 
     return (
          <button
           type="submit" className={`transition duration-300 ease-in-out inline-flex items-center py-2 px-4 text-xs font-bold text-center text-white bg-gray-950 rounded-md ${width} hover:bg-indigo-700`}
          onClick={onClick}>
             {caption}
         </button>
     )
}

const GrayButton = ({caption, onClick, fontSize}) => { 
     return (
          <button type="submit" className={`min-h-10 max-h-10 transition duration-300 ease-in-out inline-flex items-center py-2 px-4 text-xs text-center text-gray-600 bg-gray-200 rounded-md hover:bg-gray-300`}
          onClick={onClick}>
             {caption}
         </button>
     )
}

const SlateLightButton = ({caption, onClick, isActive}) => { 
     return (
          <button type="submit" className={`min-h-10 max-h-10 min-w-20 justify-center transition duration-300 ease-in-out inline-flex items-center py-2 px-4 text-xs text-center text-slate-600 bg-slate-100 rounded-md border dark:border-2 ${isActive ? 'border-teal-400' : 'border-slate-100'} hover:border-teal-400 hover:bg-slate-50`}
          onClick={onClick}>
             {caption}
         </button>
     )
}

const RedButton = ({caption, onClick}) => { 
     return (
          <button type="submit" className="w-full whitespace-nowrap  justify-center min-h-10 max-h-10 transition duration-300 ease-in-out inline-flex items-center py-2 px-4 text-xs text-center text-red-600 rounded-md hover:bg-red-500 border-2 border-red-400 hover:text-white"
          onClick={onClick}>
             {caption}
         </button>
     )
}

export  {IndigoButton, SlateLightButton, VioletButton, GrayButton, RedButton, BlackButton, FuchsiaButton, PinkButton, TealButton, GradientButton, PlaneButton, FloppyDiskButton, ArrowUpButton, CommentButton, TrashButton, FollowButton, MessageButton, MediaAttachmentButton, AnonymousButton, MinusButton, OpenUrlButton, ConfirmOrCancelButton, CopyUrlButton, TimelessPostButton, PreviewPostButton, EditButton, LinkButton, SocialShareButton, MultipurposeOvalButton, NewRecordButton, RoundButton}